export type ViewBounds = { west: number; south: number; east: number; north: number };

export function expandedView(view: ViewBounds, margin = 0.6): ViewBounds {
  const dx = (view.east - view.west) * margin,
    dy = (view.north - view.south) * margin;
  return {
    west: view.west - dx,
    east: view.east + dx,
    south: Math.max(-85.051129, view.south - dy),
    north: Math.min(85.051129, view.north + dy),
  };
}

export function containsView(outer: ViewBounds, inner: ViewBounds): boolean {
  return (
    inner.west >= outer.west && inner.east <= outer.east && inner.south >= outer.south && inner.north <= outer.north
  );
}

const geometryBounds = new WeakMap<GeoJSON.Geometry, ViewBounds>();
export function featureInView(feature: GeoJSON.Feature, view: ViewBounds): boolean {
  const geometry = feature.geometry;
  if (!geometry || geometry.type === "GeometryCollection") return true;
  let bounds = geometryBounds.get(geometry);
  if (!bounds) {
    bounds = { west: Infinity, south: Infinity, east: -Infinity, north: -Infinity };
    const visit = (coordinates: any[]): void => {
      if (typeof coordinates[0] === "number") {
        bounds.west = Math.min(bounds.west, coordinates[0]);
        bounds.east = Math.max(bounds.east, coordinates[0]);
        bounds.south = Math.min(bounds.south, coordinates[1]);
        bounds.north = Math.max(bounds.north, coordinates[1]);
      } else for (const child of coordinates) visit(child);
    };
    visit(geometry.coordinates);
    geometryBounds.set(geometry, bounds);
  }
  return (
    bounds.west <= view.east && bounds.east >= view.west && bounds.south <= view.north && bounds.north >= view.south
  );
}
